// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  useEmulators: false, // Disable emulators for staging
  firebaseConfig: {
    apiKey: "AIzaSyCrrCBttkN9sccv4jvu09PLR4CSOZ-52bg",
    authDomain: "gno-knews-staging.firebaseapp.com",
    projectId: "gno-knews-staging",
    storageBucket: "gno-knews-staging.firebasestorage.app",
    messagingSenderId: "406721861166",
    appId: "1:406721861166:web:1044ef969ef2f861f6b1bf"
  },
  generativeAI: {
    apiKey: '', // Set via deployment pipeline
    model: 'gemini-2.5-flash-lite'
  },
  spotify: {
    clientId:    '8445d919496d48f3b2be9e997b7f1e0d',
    redirectUri: 'https://lingdisco.com/spotify-callback',
    scopes: [
      'user-read-private',
      'user-read-email',
      'user-read-playback-state',
      'user-modify-playback-state',
    ],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.